/* eslint-disable */
// @ts-nocheck
import { createSelector } from 'reselect';
import { selectHasAdNetworkOrAgencyTaggedDataRestrictions } from '../../../../main/selectors/AccessControlSelectors';
export const selectDisableOrganicToggle = createSelector(
  selectHasAdNetworkOrAgencyTaggedDataRestrictions,
  (props) => props.disableOrganicToggle,
  (hasAdNetworkOrAgencyTaggedDataRestrictions, disableOrganicToggle) => {
    if (hasAdNetworkOrAgencyTaggedDataRestrictions) {
      return true;
    }

    return disableOrganicToggle;
  }
);
